
import { cn } from "@/lib/utils";

interface TestimonialCardProps {
  content: string;
  author: string;
  role?: string;
  className?: string;
  delay?: number;
}

const TestimonialCard = ({ 
  content, 
  author, 
  role, 
  className, 
  delay = 0 
}: TestimonialCardProps) => {
  return (
    <div 
      className={cn(
        "bg-white p-8 rounded-2xl shadow-soft h-full transition-all duration-500 animate-fade-in hover:shadow-elevation hover:-translate-y-1", 
        className
      )}
      style={{ 
        animationDelay: `${delay}ms`,
        opacity: 0,
        animation: `fade-in 0.6s ease-out ${delay}ms forwards`
      }}
    >
      <div className="text-4xl text-primary/40 mb-4">"</div>
      <p className="text-joerg-700 italic">
        {content}
      </p>
      <div className="mt-6 pt-4 border-t border-joerg-100">
        <p className="font-semibold text-joerg-800">{author}</p>
        {role && <p className="text-sm text-joerg-500">{role}</p>}
      </div>
    </div>
  );
};

export default TestimonialCard;
